import { PersonModel } from '@/types';

export const person: PersonModel = {
  name: 'Maciej',
  surname: 'Tułaza',
  position: 'Head of Development',
  linkedinLink: 'https://www.linkedin.com/in/maciej-tu%C5%82aza-b43999110/'
};
